import { z } from 'zod';
import { ValidationMessages } from './validationMessages';

export const maxLengthValidation = (length: number) =>
  z
    .string()
    .trim()
    .max(length, ValidationMessages.maxLength(length))
    .nullable()
    .transform((v) => v?.trim() || null);

export const requiredWithMaxLengthValidation = (length: number) =>
  z
    .string({ required_error: ValidationMessages.required })
    .trim()
    .min(1, { message: ValidationMessages.required })
    .max(length, ValidationMessages.maxLength(length));
